import Business from './Business'
import { Container } from './styles'

export default function LogInBusinessList ({
  businesses = [],
  selectedBusiness = null,
  onSelect: handleSelect
}) {
  return (
    <Container>
      {businesses.map (business => (
        <Business
          key={business.id}
          data={business}
          selected={selectedBusiness?.id === business.id}
          onSelect={handleSelect}
        />
      ))}
    </Container>
  )
}
